import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'empty-datasource',
  templateUrl: './empty-datasource.component.html',
  styleUrls: ['./empty-datasource.component.scss']
})
export class EmptyDataSource implements OnInit {

  @Input() dataSource: MatTableDataSource<any>;

  @HostBinding('style.display') get nowRows() {
    return !this.dataSource || this.dataSource.data.length == 0 ? 'flex' : 'none';
  }

  constructor(
  ) { }

  ngOnInit() {
  }

}
